module.exports = __webpack_public_path__ + "static/media/wrenchIcon.6eb54e97.png";